import React from 'react';

import SentimentBullet from './SentimentBullet';
import Gauge from './Gauge';

const Emphasized = ({ children }) => (
    <strong className="font-extrabold text-primary">{children}</strong>
);

const ResultItem = ({ sentiment, children }) => (
    <li className="flex items-center mb-3 text-body">
      <SentimentBullet sentiment={sentiment} />
      <span>{children}</span>
    </li>
);

const CalculatorResultsSummary = ({ form }) => {
    return (
      <div className="">
        <h1 className="mt-0 mb-5 text-center sm:text-left">Refinancing could benefit you.</h1>
      
        <div className="p-5 pb-0 rounded-lg bg-gray-lightest sm:p-8">
          <h2 className="mt-0 text-lg leading-none text-center text-primary mb-7 sm:text-left">Refinance Results Summary</h2>
        
          <div className="grid grid-cols-1 sm:grid-cols-5 sm:gap-7">
              <div className="flex items-center justify-center col-span-2 mb-5">
                  <Gauge className="w-full max-w-80"/>
              </div>
            
              <ul className="flex flex-col justify-center col-span-3 p-0 m-0 mb-3">
                  <ResultItem sentiment="positive">
                    You'll save <Emphasized>$431</Emphasized> each month
                  </ResultItem>
                  <ResultItem sentiment="positive">
                    You'll save <Emphasized>$75,000</Emphasized> in interest if you keep the loan for its full term
                  </ResultItem>
                  <ResultItem sentiment="negative">
                    Your loan will increase by <Emphasized>$6500</Emphasized>
                  </ResultItem>
                  <ResultItem sentiment="negative">
                    It will take you <Emphasized>2.5 years</Emphasized> longer to pay off your loan
                  </ResultItem>
                  <ResultItem sentiment="neutral">
                    You'll recover your closing costs in <Emphasized>15 months</Emphasized>
                  </ResultItem>
              </ul>
          </div>
        </div>
      </div>
    );
};

export default CalculatorResultsSummary;